//Set enumeration for themes
export enum Theme{
    VIRTUALLAUNDRY = 'virtuallaundry',
    NEWASCO = 'newasco',
    WASMIJNWAS = 'wasmijnwas',
  }
  
  //Set configuration for each app
  const themeConfig = {
    [Theme.VIRTUALLAUNDRY]: {
      appId: 'com.it2.virtuallaundry',
      appName: 'VL App',
      defaultLanguage: 'nl-NL'
    },
    [Theme.NEWASCO]: {
      appId: 'com.it2.newasco',
      appName: 'Newasco App',
      defaultLanguage: 'nl-NL',
      webportalUrl: 'https://newasco.virtuallaundry.net/service.asmx'
    },
    [Theme.WASMIJNWAS]: {
      appId: 'com.it2.wasmijnwas',
      appName: 'Wasmijnwas',
      defaultLanguage: 'nl-NL',
      webportalUrl: 'https://wasmijnwas.virtuallaundry.net/service.asmx'
    }
  };
  
  //Change this to set the app that should be build
  export const currentTheme: Theme = Theme.NEWASCO;

  //Set themeConfig according to currentTheme
  export const { appId, appName, webportalUrl, defaultLanguage } = themeConfig[currentTheme] as any;
